/**
 * Opens links that point to a different domain in a new browser tab.
 * Matches Shrine 2.0.0 behaviour ("external links open in new tabs by default").
 *
 * - Only absolute http(s) links to a different hostname are affected.
 * - Links that already declare a `target` are left untouched.
 * - `rel="noopener noreferrer"` is added for security/privacy.
 */
(function () {
  function markExternalLinks(root) {
    var host = window.location.hostname;
    var links = (root || document).querySelectorAll('a[href^="http"]:not([target])');

    Array.prototype.forEach.call(links, function (link) {
      if (!link.hostname || link.hostname === host) return;

      link.setAttribute('target', '_blank');

      var rel = (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      if (rel.indexOf('noopener') === -1) rel.push('noopener');
      if (rel.indexOf('noreferrer') === -1) rel.push('noreferrer');
      link.setAttribute('rel', rel.join(' '));
    });
  }

  /**
   * Shopify injects an "exit interstitial" ("Are you sure you want to leave …?")
   * for links to hosts outside its allowlist (e.g. wa.me). It waits for the click
   * to bubble to `window` and skips clicks that are already defaultPrevented, so
   * external links are opened here directly before that happens.
   */
  function openExternalDirectly(event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || link.hasAttribute('download')) return;
    if (link.protocol !== 'http:' && link.protocol !== 'https:') return;
    if (!link.hostname || link.hostname === window.location.hostname) return;

    event.preventDefault();
    window.open(link.href, '_blank', 'noopener,noreferrer');
  }

  if (document.readyState !== 'loading') {
    markExternalLinks(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      markExternalLinks(document);
    });
  }

  document.addEventListener('click', openExternalDirectly);
})();
